import { configureStore } from '@reduxjs/toolkit'
import {combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage
import appSlice from './reducers/app'

const persistConfig = {
    key: 'root',
    storage,
    // whitelist: ['account', 'companyId', 'locations', 'productData', 'customersWeb', 'companyIds']
    whitelist: ['app']
}


const reducers = combineReducers({
    app: appSlice
})

const persistedReducer = persistReducer(persistConfig, reducers)


const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: {
            ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
          }
        }),
    devTools: process.env.NODE_ENV !== 'production', // Enable devTools only in development mode
})

export const persistor = persistStore(store)
export default store